module.exports = "<div id=\"thirdPartyWalletContainer\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-third-party-wallet/template.html
// module id = ./pages/xo-third-party-wallet/template.html
// module chunks = 0